var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.06 9.06) scale(1.12)",
    stroke: "#343334",
    strokeWidth: 0.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 2v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 4h-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 20,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewness);
export default __webpack_public_path__ + "static/media/Newness.75682bda9cf50ed0567f7ef5795ead7f.svg";
export { ForwardRef as ReactComponent };